import React from "react";
import "../../css_files/Enquiry/Steps.css";

function Steps({ catchStep }) {
  return (
    <section className="checkin-steps">
      <aside>
        <blockquote>
          <button
            style={{
              backgroundColor: catchStep === "step1" && "blue",
              borderColor: catchStep === "step1" && "blue",
            }}
          >
            <i
              class="fa-solid fa-1"
              style={{ color: catchStep === "step1" && "white" }}
            ></i>
          </button>
          <h3 style={{ color: catchStep === "step1" && "blue" }}>TICKET</h3>
        </blockquote>
        <i
          className="fa-solid fa-angle-right"
          style={{ color: catchStep === "step1" && "blue" }}
        ></i>
        <blockquote>
          <button
            style={{
              backgroundColor: catchStep === "step2" && "blue",
              borderColor: catchStep === "step2" && "blue",
            }}
          >
            <i
              class="fa-solid fa-2"
              style={{ color: catchStep === "step2" && "white" }}
            ></i>
          </button>
          <h3 style={{ color: catchStep === "step2" && "blue" }}>SERVICES</h3>
        </blockquote>
        <i
          className="fa-solid fa-angle-right"
          style={{ color: catchStep === "step2" && "blue" }}
        ></i>
        <blockquote>
          <button
            style={{
              backgroundColor: catchStep === "step3" && "blue",
              borderColor: catchStep === "step3" && "blue",
            }}
          >
            <i
              class="fa-solid fa-3"
              style={{ color: catchStep === "step3" && "white" }}
            ></i>
          </button>
          <h3 style={{ color: catchStep === "step3" && "blue" }}>
            SHOW QUOTATION
          </h3>
        </blockquote>
        <i
          className="fa-solid fa-angle-right"
          style={{ color: catchStep === "step3" && "blue" }}
        ></i>
        <blockquote>
          <button
            style={{
              backgroundColor: catchStep === "step4" && "blue",
              borderColor: catchStep === "step4" && "blue",
            }}
          >
            <i
              class="fa-solid fa-4"
              style={{ color: catchStep === "step4" && "white" }}
            ></i>
          </button>
          <h3 style={{ color: catchStep === "step4" && "blue" }}>ORDER</h3>
        </blockquote>
        <i
          className="fa-solid fa-angle-right"
          style={{ color: catchStep === "step4" && "blue" }}
        ></i>
        <blockquote>
          <button
            style={{
              backgroundColor: catchStep === "step5" && "blue",
              borderColor: catchStep === "step5" && "blue",
            }}
          >
            <i
              class="fa-solid fa-5"
              style={{ color: catchStep === "step5" && "white" }}
            ></i>
          </button>
          <h3 style={{ color: catchStep === "step5" && "blue" }}>INVOICE</h3>
        </blockquote>
      </aside>
    </section>
  );
}

export default Steps;
